// extracted by mini-css-extract-plugin
module.exports = {"draftUploadHeading":"DraftUpdate_draftUploadHeading__YCWX5","mainHeadline":"DraftUpdate_mainHeadline__1lHxZ"};